import script from "./EditInformationOtpConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInformationOtpConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./EditInformationOtpConfirmation.vue?vue&type=style&index=0&id=c6aed788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6aed788"]])

export default __exports__